import { getIsPadWidth } from '@elem/utils/devices';
import Head from 'next/head';
import { useProductStore } from '../ProductProvider';
import { IPageStatus } from '../config/IPageStatus';
import Banner from './comps/Banner';
import SectionA from './comps/SectionA';
import SectionB from './comps/SectionB';
import SectionC from './comps/SectionC';
import SectionD from './comps/SectionD';
import SectionE from './comps/SectionE';
import SectionF from './comps/SectionF';
import SectionG from './comps/SectionG';
import SectionH from './comps/SectionH';
import SectionI from './comps/SectionI';
import SectionJ from './comps/SectionJ';
import FootTC from './comps/FootTC';
import BarL from './comps/BarL';
import styles from './index.module.scss';
import TextComp from './comps/SectionF/TextComp';

// 产品图
export const PRODUCT_D3P = 'https://websiteoss.ecoflow.com/upload/image/1723002915019/sl_d3p.png';
export const PRODUCT_R3 = 'https://websiteoss.ecoflow.com/upload/image/1723010253085/sl_r3.png';
export const PRODUCT_R3P = 'https://websiteoss.ecoflow.com/upload/image/1723010252921/sl_r3p.png';
export const PRODUCT_PB5000 = 'https://websiteoss.ecoflow.com/upload/image/1723518823004/RAPID_5000.png';
export const PRODUCT_PB10000 = 'https://websiteoss.ecoflow.com/upload/image/1723518823259/RAPID_10000.png';

export default function Teaser() {
    const { pageStatus } = useProductStore();
    const ICON1 = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="1072" height="2058" viewBox="0 0 1072 2058" fill="none">
            <g opacity="0.66" filter="url(#filter0_f_305_10218)">
                <path
                    d="M-261.02 813.256C-597.903 1046.19 -804.192 1331.63 -721.781 1450.82C-639.37 1570.01 -299.465 1477.81 37.4169 1244.88C374.299 1011.95 580.589 726.503 498.178 607.313C415.767 488.123 75.8621 580.327 -261.02 813.256Z"
                    fill="url(#paint0_linear_305_10218)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_f_305_10218"
                    x="-1294.91"
                    y="0.203613"
                    width="2366.22"
                    height="2057.73"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="277.5" result="effect1_foregroundBlur_305_10218" />
                </filter>
                <linearGradient id="paint0_linear_305_10218" x1="180.58" y1="747.634" x2="-78.9152" y2="1496.44" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF5C00" />
                    <stop offset="0.485974" stopColor="#FF7777" />
                    <stop offset="1" stopColor="#FFC83A" />
                </linearGradient>
            </defs>
        </svg>
    );
    const ICON1_PAD = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="503" height="1264" viewBox="0 0 503 1264" fill="none">
            <g opacity="0.66" filter="url(#filter0_f_308_13054)">
                <path
                    d="M-309.392 766.917C-516.282 621.042 -642.971 442.275 -592.36 367.631C-541.749 292.986 -333.003 350.73 -126.113 496.606C80.7776 642.481 207.467 821.248 156.855 895.892C106.244 970.537 -102.502 912.793 -309.392 766.917Z"
                    fill="url(#paint0_linear_308_13054)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_f_308_13054"
                    x="-938.396"
                    y="0.0965881"
                    width="1441.29"
                    height="1263.33"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="167.45" result="effect1_foregroundBlur_308_13054" />
                </filter>
                <linearGradient id="paint0_linear_308_13054" x1="-38.1915" y1="808.014" x2="-203.209" y2="341.063" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF5C00" />
                    <stop offset="0.485974" stopColor="#FF7777" />
                    <stop offset="1" stopColor="#FFC83A" />
                </linearGradient>
            </defs>
        </svg>
    );
    const ICON2 = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="998" height="1871" viewBox="0 0 998 1871" fill="none">
            <g opacity="0.66" filter="url(#filter0_f_305_10217)">
                <path
                    d="M1033.98 1057.88C697.097 824.952 490.808 539.503 573.219 420.313C655.63 301.123 995.535 393.327 1332.42 626.256C1669.3 859.186 1875.59 1144.63 1793.18 1263.82C1710.77 1383.02 1370.86 1290.81 1033.98 1057.88Z"
                    fill="url(#paint0_linear_305_10217)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_f_305_10217"
                    x="0.0859375"
                    y="-186.796"
                    width="2366.22"
                    height="2057.73"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="277.5" result="effect1_foregroundBlur_305_10217" />
                </filter>
                <linearGradient id="paint0_linear_305_10217" x1="1475.58" y1="1123.5" x2="1216.08" y2="374.701" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF5C00" />
                    <stop offset="0.485974" stopColor="#FF7777" />
                    <stop offset="1" stopColor="#FFC83A" />
                </linearGradient>
            </defs>
        </svg>
    );
    const ICON2_PAD = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="673" height="1152" viewBox="0 0 673 1152" fill="none">
            <g opacity="0.66" filter="url(#filter0_f_307_13053)">
                <path
                    d="M629.608 654.786C422.718 508.911 296.029 330.144 346.64 255.5C397.251 180.855 605.997 238.599 812.887 384.475C1019.78 530.35 1146.47 709.117 1095.86 783.761C1045.24 858.405 836.498 800.661 629.608 654.786Z"
                    fill="url(#paint0_linear_307_13053)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_f_307_13053"
                    x="0.603912"
                    y="-112.035"
                    width="1441.29"
                    height="1263.33"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="167.45" result="effect1_foregroundBlur_307_13053" />
                </filter>
                <linearGradient id="paint0_linear_307_13053" x1="900.809" y1="695.883" x2="735.791" y2="228.932" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF5C00" />
                    <stop offset="0.485974" stopColor="#FF7777" />
                    <stop offset="1" stopColor="#FFC83A" />
                </linearGradient>
            </defs>
        </svg>
    );
    const isPad = getIsPadWidth();

    return (
        <div className={styles.teaser}>
            <Head>
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="どんなシーンでも活躍する次世代パワー｜EcoFlow JP" />
                <meta name="twitter:description" content="シンプル、柔軟、そして信頼できる電力ソリューション、あらゆるライフスタイルに対応します。" />
                <meta name="twitter:image" content="https://cdn.shopify.com/s/files/1/0412/3459/6001/files/Frame_1000008125.png?v=1723199687" />
            </Head>
            <Banner />
            <SectionA />
            <SectionB />
            <SectionC />
            <div className="linear-gradient">
                <div className="icon-left">{isPad ? <ICON1_PAD /> : <ICON1 />}</div>
                <div className="icon-right">{isPad ? <ICON2_PAD /> : <ICON2 />}</div>
                {pageStatus !== IPageStatus.statusC && <SectionD />}
                <SectionE pageStatus={pageStatus} />
                {pageStatus !== IPageStatus.statusC && <SectionF />}
                <SectionG />
                {pageStatus !== IPageStatus.statusC && <SectionH />}
            </div>
            <SectionI />
            {pageStatus === IPageStatus.statusC && (
                <div className="line">
                    <TextComp />
                </div>
            )}
            <SectionJ />
            <FootTC />
            <BarL />
        </div>
    );
}
